// import { createSelector } from 'reselect';

export const getItems = (state:any) => state.mapPoi.items;
export const getIsFetching = (state:any) => state.mapPoi.isFetching;
export const getIsLoading = (state:any) => state.mapPoi.isLoading;
export const getStatus = (state:any) => state.mapPoi.status;
